import type { ComponentType } from 'react';
import SunEditorImport from 'suneditor-react';

/** Vite CJS interop: default export is often `{ default, buttonList }`. */
const SunEditor = (
  typeof SunEditorImport === 'function'
    ? SunEditorImport
    : (SunEditorImport as unknown as { default: ComponentType<any> }).default
) as ComponentType<any>;

export default SunEditor;
